// test904
(904 && 0);
